var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlaystore(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 204.698,
    height: 76.761,
    viewBox: "0 0 204.698 76.761",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1781",
    "data-name": "Group 1781",
    transform: "translate(-424.152 -5838.119)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "iOS_App",
    "data-name": "iOS App",
    transform: "translate(424.152 5838.119)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2230",
    "data-name": "Path 2230",
    d: "M197.115,1.535a5.781,5.781,0,0,1,4.5,2.36,9.259,9.259,0,0,1,1.865,5.7V67.166a9.259,9.259,0,0,1-1.865,5.7,5.781,5.781,0,0,1-4.5,2.36H7.582a5.781,5.781,0,0,1-4.5-2.36,9.257,9.257,0,0,1-1.865-5.7V9.6A9.256,9.256,0,0,1,3.078,3.9a5.78,5.78,0,0,1,4.5-2.36Zm0-1.535H7.582a6.882,6.882,0,0,0-5.36,2.815A11.02,11.02,0,0,0,0,9.6V67.166a11.02,11.02,0,0,0,2.221,6.781,6.882,6.882,0,0,0,5.36,2.815H197.115a6.882,6.882,0,0,0,5.36-2.815,11.021,11.021,0,0,0,2.221-6.781V9.6a11.022,11.022,0,0,0-2.221-6.781A6.882,6.882,0,0,0,197.115,0Z",
    transform: "translate(0.001 0)",
    fill: "#fff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_308",
    "data-name": "Group 308",
    transform: "translate(23.647 17.912)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2231",
    "data-name": "Path 2231",
    d: "M50,30.31a8.375,8.375,0,0,1,3.989-7.027,8.572,8.572,0,0,0-6.756-3.653c-2.841-.3-5.6,1.7-7.047,1.7-1.476,0-3.71-1.672-6.109-1.622a8.994,8.994,0,0,0-7.57,4.617c-3.274,5.668-.832,14,2.3,18.579,1.568,2.244,3.4,4.749,5.8,4.661,2.348-.1,3.225-1.5,6.058-1.5,2.807,0,3.631,1.5,6.078,1.441,2.519-.041,4.105-2.254,5.62-4.517a18.542,18.542,0,0,0,2.57-5.234A8.1,8.1,0,0,1,50,30.31Z",
    transform: "translate(-24.951 -10.71)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2232",
    "data-name": "Path 2232",
    d: "M46.192,16.126a8.243,8.243,0,0,0,1.887-5.908,8.4,8.4,0,0,0-5.43,2.815,7.845,7.845,0,0,0-1.936,5.689,6.937,6.937,0,0,0,5.478-2.6Z",
    transform: "translate(-25.769 -10.218)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2233",
    "data-name": "Path 2233",
    d: "M86.338,47.706H83.056l-1.791-5.647H75.011L73.3,47.706H70.1L76.295,28.48h3.823ZM80.719,39.69l-1.625-5.02q-.256-.768-.97-3.622h-.058q-.284,1.227-.913,3.622l-1.6,5.02Z",
    transform: "translate(-27.316 -11.173)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2234",
    "data-name": "Path 2234",
    d: "M103.29,40.885a7.881,7.881,0,0,1-1.911,5.589A5.591,5.591,0,0,1,97.128,48.3a4.25,4.25,0,0,1-3.937-1.973h-.058v7.3H90.053V38.687q0-2.224-.114-4.563h2.708l.171,2.2h.058a5.481,5.481,0,0,1,8.771-.544A7.642,7.642,0,0,1,103.29,40.885ZM100.152,41a5.71,5.71,0,0,0-.912-3.338,3.154,3.154,0,0,0-2.687-1.37,3.2,3.2,0,0,0-2.067.756,3.505,3.505,0,0,0-1.213,1.984,4.032,4.032,0,0,0-.143.939V42.28a3.71,3.71,0,0,0,.928,2.559,3.07,3.07,0,0,0,2.41,1.041,3.154,3.154,0,0,0,2.714-1.345,5.9,5.9,0,0,0,.97-3.539Z",
    transform: "translate(-28.353 -11.454)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2235",
    "data-name": "Path 2235",
    d: "M120.116,40.885a7.873,7.873,0,0,1-1.919,5.589,5.583,5.583,0,0,1-4.249,1.826,4.247,4.247,0,0,1-3.935-1.968h-.058v7.3h-3.079V38.687q0-2.224-.115-4.563h2.71l.171,2.2h.058a5.482,5.482,0,0,1,8.773-.544A7.659,7.659,0,0,1,120.116,40.885ZM116.978,41a5.7,5.7,0,0,0-.915-3.338,3.147,3.147,0,0,0-2.679-1.37,3.209,3.209,0,0,0-2.07.756,3.506,3.506,0,0,0-1.21,1.984,4.117,4.117,0,0,0-.143.939V42.28a3.71,3.71,0,0,0,.925,2.559,3.081,3.081,0,0,0,2.413,1.041,3.152,3.152,0,0,0,2.708-1.341A5.9,5.9,0,0,0,116.979,41Z",
    transform: "translate(-29.234 -11.454)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2236",
    "data-name": "Path 2236",
    d: "M139,42.3a5.124,5.124,0,0,1-1.708,3.993,7.569,7.569,0,0,1-5.236,1.684,9.169,9.169,0,0,1-4.983-1.2l.714-2.568a8.444,8.444,0,0,0,4.452,1.228,4.212,4.212,0,0,0,2.712-.786,2.568,2.568,0,0,0,.967-2.1,2.676,2.676,0,0,0-.8-1.97,7.42,7.42,0,0,0-2.652-1.487q-5.05-1.883-5.047-5.513a4.879,4.879,0,0,1,1.769-3.885,6.978,6.978,0,0,1,4.707-1.513,9.332,9.332,0,0,1,4.363.913l-.768,2.511a7.568,7.568,0,0,0-3.679-.884,3.723,3.723,0,0,0-2.537.8,2.281,2.281,0,0,0-.768,1.741,2.349,2.349,0,0,0,.883,1.882,9.993,9.993,0,0,0,2.8,1.484,9.487,9.487,0,0,1,3.65,2.337A4.882,4.882,0,0,1,139,42.3Z",
    transform: "translate(-30.297 -11.159)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2237",
    "data-name": "Path 2237",
    d: "M149.944,36.259H146.55V42.99q0,2.568,1.791,2.568a5.479,5.479,0,0,0,1.369-.143l.086,2.339a6.985,6.985,0,0,1-2.4.342,3.7,3.7,0,0,1-2.853-1.113,5.465,5.465,0,0,1-1.023-3.738V36.259H141.5V33.945h2.023V31.406l3.026-.913v3.454h3.4Z",
    transform: "translate(-31.052 -11.279)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2238",
    "data-name": "Path 2238",
    d: "M165.827,40.943A7.6,7.6,0,0,1,164,46.188a6.525,6.525,0,0,1-5.08,2.111,6.2,6.2,0,0,1-4.862-2.024,7.374,7.374,0,0,1-1.812-5.106,7.529,7.529,0,0,1,1.868-5.276,6.465,6.465,0,0,1,5.033-2.055,6.33,6.33,0,0,1,4.906,2.025,7.292,7.292,0,0,1,1.772,5.079Zm-3.2.1a6.234,6.234,0,0,0-.826-3.289,3.042,3.042,0,0,0-2.766-1.663,3.088,3.088,0,0,0-2.824,1.663,6.355,6.355,0,0,0-.826,3.348,6.225,6.225,0,0,0,.826,3.288,3.148,3.148,0,0,0,5.563-.029,6.26,6.26,0,0,0,.856-3.317Z",
    transform: "translate(-31.615 -11.456)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2239",
    "data-name": "Path 2239",
    d: "M176.731,36.831a5.359,5.359,0,0,0-.971-.086,2.909,2.909,0,0,0-2.51,1.228,4.617,4.617,0,0,0-.768,2.738V47.99H169.4l.029-9.5q0-2.4-.115-4.365H172l.113,2.652h.086a4.733,4.733,0,0,1,1.535-2.2,3.723,3.723,0,0,1,2.226-.742,4.955,4.955,0,0,1,.768.056Z",
    transform: "translate(-32.506 -11.454)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2240",
    "data-name": "Path 2240",
    d: "M191,40.4a7.213,7.213,0,0,1-.113,1.4h-9.241a4.021,4.021,0,0,0,1.341,3.14,4.577,4.577,0,0,0,3.022.97,10.216,10.216,0,0,0,3.738-.656l.484,2.138a11.565,11.565,0,0,1-4.648.857,6.735,6.735,0,0,1-5.065-1.9,7.008,7.008,0,0,1-1.838-5.092,7.942,7.942,0,0,1,1.713-5.22,5.9,5.9,0,0,1,4.847-2.224,5.166,5.166,0,0,1,4.538,2.224A7.5,7.5,0,0,1,191,40.4Zm-2.943-.8a4.177,4.177,0,0,0-.6-2.368A2.687,2.687,0,0,0,185,35.952a2.922,2.922,0,0,0-2.451,1.255,4.6,4.6,0,0,0-.912,2.395h6.416Z",
    transform: "translate(-32.999 -11.454)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2241",
    "data-name": "Path 2241",
    d: "M79.8,15.75a4.743,4.743,0,0,1-1.529,3.838,6.079,6.079,0,0,1-4.021,1.191,18.639,18.639,0,0,1-2.215-.113V11.377a16.345,16.345,0,0,1,2.607-.2,5.621,5.621,0,0,1,3.75,1.08A4.361,4.361,0,0,1,79.8,15.75Zm-1.6.042a3.454,3.454,0,0,0-.875-2.537,3.454,3.454,0,0,0-2.559-.883,6.411,6.411,0,0,0-1.219.1v7.063a7.991,7.991,0,0,0,1.023.042,3.582,3.582,0,0,0,2.687-.967,3.87,3.87,0,0,0,.947-2.817Z",
    transform: "translate(-27.417 -10.272)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2242",
    "data-name": "Path 2242",
    d: "M88.792,17.374a3.736,3.736,0,0,1-.9,2.579A3.2,3.2,0,0,1,85.4,20.991a3.044,3.044,0,0,1-2.39-1,3.626,3.626,0,0,1-.889-2.508A3.7,3.7,0,0,1,83.04,14.9a3.182,3.182,0,0,1,2.473-1.008,3.115,3.115,0,0,1,2.412.994A3.6,3.6,0,0,1,88.792,17.374Zm-1.571.049a3.081,3.081,0,0,0-.406-1.617,1.5,1.5,0,0,0-1.359-.815,1.519,1.519,0,0,0-1.388.815,3.122,3.122,0,0,0-.406,1.644,3.081,3.081,0,0,0,.406,1.617,1.528,1.528,0,0,0,1.374.815,1.511,1.511,0,0,0,1.359-.829,3.06,3.06,0,0,0,.42-1.63Z",
    transform: "translate(-27.944 -10.411)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2243",
    "data-name": "Path 2243",
    d: "M100.592,14.032,98.46,20.844H97.073l-.879-2.958a22.131,22.131,0,0,1-.548-2.2H95.62a16.1,16.1,0,0,1-.548,2.2l-.938,2.958H92.727l-2-6.811H92.28l.768,3.238q.28,1.151.462,2.186h.027q.169-.853.562-2.175l.967-3.251H96.3l.926,3.182q.336,1.164.546,2.243h.042a21.458,21.458,0,0,1,.462-2.243l.826-3.182h1.487Z",
    transform: "translate(-28.394 -10.418)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2244",
    "data-name": "Path 2244",
    d: "M109.089,20.836h-1.516v-3.9q0-1.8-1.373-1.8a1.366,1.366,0,0,0-1.094.5,1.76,1.76,0,0,0-.421,1.167v4.039h-1.513V15.971q0-.9-.055-1.948h1.331l.072,1.064h.042a2.184,2.184,0,0,1,.784-.823,2.559,2.559,0,0,1,1.373-.384,2.175,2.175,0,0,1,1.585.617,3,3,0,0,1,.784,2.257Z",
    transform: "translate(-29.043 -10.411)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2245",
    "data-name": "Path 2245",
    d: "M113.74,20.669h-1.512V10.735h1.512Z",
    transform: "translate(-29.519 -10.246)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2246",
    "data-name": "Path 2246",
    d: "M122.862,17.374a3.737,3.737,0,0,1-.9,2.579,3.2,3.2,0,0,1-2.495,1.038,3.038,3.038,0,0,1-2.389-1,3.626,3.626,0,0,1-.889-2.508,3.7,3.7,0,0,1,.917-2.592,3.183,3.183,0,0,1,2.473-1.008,3.12,3.12,0,0,1,2.413.994A3.6,3.6,0,0,1,122.862,17.374Zm-1.572.049a3.081,3.081,0,0,0-.406-1.617,1.494,1.494,0,0,0-1.357-.815,1.516,1.516,0,0,0-1.388.815,3.127,3.127,0,0,0-.406,1.644,3.082,3.082,0,0,0,.406,1.617,1.535,1.535,0,0,0,1.374.815,1.51,1.51,0,0,0,1.357-.829,3.05,3.05,0,0,0,.42-1.63Z",
    transform: "translate(-29.727 -10.411)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2247",
    "data-name": "Path 2247",
    d: "M130.654,20.835h-1.36l-.111-.784h-.042a2.331,2.331,0,0,1-1.989.939,2.047,2.047,0,0,1-1.554-.617,1.934,1.934,0,0,1-.534-1.387,2.116,2.116,0,0,1,1.044-1.906,5.423,5.423,0,0,1,2.942-.64v-.128q0-1.346-1.415-1.345a3.164,3.164,0,0,0-1.774.5l-.308-.994a4.368,4.368,0,0,1,2.336-.589q2.67,0,2.673,2.815v2.508a10.579,10.579,0,0,0,.093,1.624Zm-1.577-2.341v-1.05q-2.5-.044-2.5,1.373a1.023,1.023,0,0,0,.29.8,1.059,1.059,0,0,0,.741.266,1.527,1.527,0,0,0,.926-.315,1.288,1.288,0,0,0,.525-.806,1.264,1.264,0,0,0,.023-.267Z",
    transform: "translate(-30.191 -10.41)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2248",
    "data-name": "Path 2248",
    d: "M139.683,20.669H138.34l-.07-1.094h-.042a2.263,2.263,0,0,1-2.188,1.249,2.559,2.559,0,0,1-2.047-.967,3.764,3.764,0,0,1-.812-2.508,3.948,3.948,0,0,1,.883-2.678,2.716,2.716,0,0,1,2.1-.953,2.047,2.047,0,0,1,1.919.925h.029V10.735h1.515v8.1Q139.629,19.83,139.683,20.669ZM138.114,17.8V16.661a2.216,2.216,0,0,0-.046-.47,1.725,1.725,0,0,0-.546-.917,1.491,1.491,0,0,0-1.013-.371,1.554,1.554,0,0,0-1.333.673,2.885,2.885,0,0,0-.485,1.723,2.687,2.687,0,0,0,.466,1.64,1.558,1.558,0,0,0,1.323.672,1.46,1.46,0,0,0,1.2-.56,1.867,1.867,0,0,0,.438-1.252Z",
    transform: "translate(-30.616 -10.246)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2249",
    "data-name": "Path 2249",
    d: "M153.337,17.374a3.737,3.737,0,0,1-.9,2.579,3.2,3.2,0,0,1-2.495,1.038,3.047,3.047,0,0,1-2.389-1,3.626,3.626,0,0,1-.889-2.508,3.7,3.7,0,0,1,.917-2.592,3.183,3.183,0,0,1,2.476-1.008,3.11,3.11,0,0,1,2.409.994A3.6,3.6,0,0,1,153.337,17.374Zm-1.57.049a3.081,3.081,0,0,0-.406-1.617,1.5,1.5,0,0,0-1.36-.815,1.522,1.522,0,0,0-1.388.815,3.118,3.118,0,0,0-.406,1.644,3.081,3.081,0,0,0,.406,1.617,1.535,1.535,0,0,0,1.374.815,1.511,1.511,0,0,0,1.359-.829,3.07,3.07,0,0,0,.422-1.63Z",
    transform: "translate(-31.322 -10.411)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2250",
    "data-name": "Path 2250",
    d: "M161.965,20.836h-1.512v-3.9q0-1.8-1.374-1.8a1.362,1.362,0,0,0-1.093.5,1.754,1.754,0,0,0-.42,1.167v4.039H156.05V15.971q0-.9-.052-1.948h1.329l.07,1.064h.042a2.2,2.2,0,0,1,.784-.823,2.566,2.566,0,0,1,1.374-.384,2.175,2.175,0,0,1,1.584.617,2.994,2.994,0,0,1,.784,2.257Z",
    transform: "translate(-31.81 -10.411)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2251",
    "data-name": "Path 2251",
    d: "M172.818,15.073h-1.663v3.308c0,.841.3,1.261.883,1.261a2.668,2.668,0,0,0,.674-.07l.038,1.151a3.4,3.4,0,0,1-1.176.169,1.809,1.809,0,0,1-1.4-.546,2.67,2.67,0,0,1-.512-1.836V15.073h-1V13.939h1V12.691l1.484-.448v1.7h1.663v1.136Z",
    transform: "translate(-32.473 -10.324)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2252",
    "data-name": "Path 2252",
    d: "M181.179,20.669h-1.519V16.8q0-1.831-1.371-1.832a1.444,1.444,0,0,0-1.444,1.062,1.88,1.88,0,0,0-.072.545v4.094h-1.512V10.735h1.512v4.1h.029a2.287,2.287,0,0,1,2.047-1.119,2.111,2.111,0,0,1,1.558.617,3.1,3.1,0,0,1,.768,2.284Z",
    transform: "translate(-32.82 -10.246)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2253",
    "data-name": "Path 2253",
    d: "M189.9,17.107a3.673,3.673,0,0,1-.056.686H185.3a1.983,1.983,0,0,0,.658,1.535,2.253,2.253,0,0,0,1.485.477,5.015,5.015,0,0,0,1.837-.322l.237,1.052a5.7,5.7,0,0,1-2.286.421,3.3,3.3,0,0,1-2.486-.931,3.43,3.43,0,0,1-.9-2.5,3.9,3.9,0,0,1,.841-2.559,2.9,2.9,0,0,1,2.381-1.093,2.534,2.534,0,0,1,2.227,1.093A3.638,3.638,0,0,1,189.9,17.107Zm-1.446-.391a2.036,2.036,0,0,0-.293-1.163,1.322,1.322,0,0,0-1.205-.631,1.438,1.438,0,0,0-1.205.617,2.3,2.3,0,0,0-.449,1.177Z",
    transform: "translate(-33.268 -10.41)",
    fill: "#fff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaystore);
export default __webpack_public_path__ + "static/media/playstore.f5efb366681a6b7b70c020d1ef49b7d7.svg";
export { ForwardRef as ReactComponent };